var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.59,
    height: 482.935,
    viewBox: "0 0 243.59 482.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Care_Halbkreis",
    transform: "translate(455.14 711.887) rotate(180)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2527",
    "data-name": "Pfad 2527",
    d: "M276.886,302.19a33.828,33.828,0,1,0-33.83-33.83,33.83,33.83,0,0,0,33.83,33.83",
    transform: "translate(90.387 16.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2530",
    "data-name": "Pfad 2530",
    d: "M253.228,322.076a33.83,33.83,0,1,0-33.83-33.83,33.833,33.833,0,0,0,33.83,33.83",
    transform: "translate(22.596 72.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2531",
    "data-name": "Pfad 2531",
    d: "M249.366,355.34a33.83,33.83,0,1,0-33.83-33.83,33.833,33.833,0,0,0,33.83,33.83",
    transform: "translate(11.476 167.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2532",
    "data-name": "Pfad 2532",
    d: "M283.162,275.1a17.93,17.93,0,1,0-17.93-17.93,17.928,17.928,0,0,0,17.93,17.93",
    transform: "translate(154.049 29.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2533",
    "data-name": "Pfad 2533",
    d: "M283.15,334.522a17.93,17.93,0,1,0,17.93,17.934,17.929,17.929,0,0,0-17.93-17.934",
    transform: "translate(154.014 300.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2535",
    "data-name": "Pfad 2535",
    d: "M250.589,255.462a10.15,10.15,0,1,0,10.148,10.148,10.147,10.147,0,0,0-10.148-10.148",
    transform: "translate(82.917 75.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2536",
    "data-name": "Pfad 2536",
    d: "M245.356,292.154a10.148,10.148,0,1,0-10.148-10.148,10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(67.898 122.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2539",
    "data-name": "Pfad 2539",
    d: "M258.087,384.742a33.831,33.831,0,1,0-33.83-33.831,33.833,33.833,0,0,0,33.83,33.831",
    transform: "translate(36.586 250.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2541",
    "data-name": "Pfad 2541",
    d: "M280.761,404.547a33.828,33.828,0,1,0-33.83-33.831,33.83,33.83,0,0,0,33.83,33.831",
    transform: "translate(101.504 307.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2545",
    "data-name": "Pfad 2545",
    d: "M224.314,297.885a10.148,10.148,0,1,0-10.148-10.148,10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(7.532 138.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2546",
    "data-name": "Pfad 2546",
    d: "M243.126,325.418a10.148,10.148,0,1,0-10.148-10.148,10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(61.498 217.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2550",
    "data-name": "Pfad 2550",
    d: "M279.38,369.395a10.148,10.148,0,1,0-10.148-10.148,10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(165.547 342.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2551",
    "data-name": "Pfad 2551",
    d: "M254.463,350.72a10.148,10.148,0,1,0-10.148-10.148,10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(94.035 288.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2552",
    "data-name": "Pfad 2552",
    d: "M229.173,312.372a10.148,10.148,0,1,0,10.148,10.148,10.147,10.147,0,0,0-10.148-10.148",
    transform: "translate(21.522 237.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2553",
    "data-name": "Pfad 2553",
    d: "M241.756,280.2A10.148,10.148,0,1,0,251.9,290.352,10.147,10.147,0,0,0,241.756,280.2",
    transform: "translate(57.566 146.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2555",
    "data-name": "Pfad 2555",
    d: "M274.77,249.248A10.148,10.148,0,1,0,264.622,239.1a10.147,10.147,0,0,0,10.148,10.148",
    transform: "translate(152.316 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2558",
    "data-name": "Pfad 2558",
    d: "M245.356,337.662A10.15,10.15,0,1,0,255.5,347.81a10.147,10.147,0,0,0-10.148-10.148",
    transform: "translate(67.898 309.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2559",
    "data-name": "Pfad 2559",
    d: "M221.7,322.8a10.148,10.148,0,1,0-10.148-10.148A10.147,10.147,0,0,0,221.7,322.8",
    transform: "translate(0 209.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2560",
    "data-name": "Pfad 2560",
    d: "M243.126,239.765a10.148,10.148,0,1,0,10.148,10.148,10.147,10.147,0,0,0-10.148-10.148",
    transform: "translate(61.498 31.133)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCBubble);
export default __webpack_public_path__ + "static/media/c_bubble.b89c29fa438dd1af6876124b432f65c2.svg";
export { ForwardRef as ReactComponent };